var utils = require('../../utils')
import AppHeader from '../AppHeader'

export default {
  name: 'rejectreason-new',
  created () {
  },
  data () {
    return {
      canValidate: true,
      contentCount: 0,
      savingFlag: false,
      reject_reason: {
        reject_reason: null,
        reject_reason_default_content: null,
        reject_reason_priority: null
      }
    }
  },
  computed: {
    validation: function () {
      var v = {
        reject_reason: !!this.reject_reason.reject_reason,
        reject_reason_default_content: !!this.reject_reason.reject_reason_default_content,
        reject_reason_priority: !!this.reject_reason.reject_reason_priority,
        not_input: !!this.reject_reason.reject_reason &&
                   !!this.reject_reason.reject_reason_default_content &&
                   !!this.reject_reason.reject_reason_priority
      }
      if (!this.canValidate) {
        Object.keys(v).forEach(key => { v[key] = true; });
      }
      return v
    },
    isValid () {
      var validation = this.validation
      return Object.keys(validation).every(function (key) {
        return validation[key]
      })
    }
  },
  components: {
    AppHeader
  },
  methods: {
    onClickSave: function () {
      if (this.savingFlag) return false
      this.canValidate = true
      if (this.isValid) {
        this.savingFlag = true
        console.log("is valid")
        this.$store.dispatch('REJECT_REASON_CREATE',
          { data: this.reject_reason, callback: this.onSaved })
      } else {
        console.log("need edit")
      }
    },
    half: function () {
      this.reject_reason.reject_reason = utils.emHalf(this.reject_reason.reject_reason)
    },
    onClickCancel: function () {
      this.$router.push({ path: '/reject_reasons', query: { type: this.$router.currentRoute.query.type}})
    },
    onSaved: function (result) {
      this.savingFlag = false
      this.$router.push('/reject_reasons')
    },
    contentCounter: function() {
      this.reject_reason.reject_reason_default_content = utils.emHalf(this.reject_reason.reject_reason_default_content)
      this.contentCount = this.reject_reason.reject_reason_default_content.length
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/scripts/rejectreason-new.js